<med-label
  [label]="label"
  [name]="name"
  [disabled]="disabled"
  [required]="required"
  [labelClass]="labelClass"
  (clickOutside)="onToggle(false)"
>
  <div [ngClass]="{ field__container: hasErrorPadding }">
    <div
      #elRef
      class="med-select"
      [ngClass]="{ extend: overlayVisible }"
    >
      <div
        #buttonRef
        class="med-select__box field"
        [ngClass]="classList"
        (click)="onToggle(!overlayVisible, $event)"
      >
        <div
          class="med-select__title"
          [innerHTML]="title"
        ></div>

        <div class="med-select__nav">
          <div
            [ngClass]="{ hide: !hasValue || disabled }"
            class="med-select__icon med-select__icon--delete"
          >
            <med-icon-x
              *ngIf="!hideClearBtn"
              size="14"
              (click)="onClear($event)"
            ></med-icon-x>
          </div>

          <div
            class="med-select__icon med-select__icon--arrow"
            [ngClass]="{ rotate: overlayVisible }"
          >
            <med-icon-chevron-down size="16"></med-icon-chevron-down>
          </div>
        </div>
      </div>

      <ul
        #popoverRef
        role="listbox"
        class="med-select__list"
      >
        <li
          *ngIf="headerTemplate"
          class="med-select__header"
        >
          <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
        </li>

        <li
          *ngIf="!options.length && emptyMessage"
          class="med-select__message"
        >
          <span class="med-select__message-content">
            {{ emptyMessage }}
          </span>
        </li>

        <li
          *ngFor="let option of options"
          class="med-select__list-item"
          [attr.tabindex]="disabled || option.disabled ? null : '0'"
          [ngClass]="{ disabled: disabled || option.disabled, active: hasActive($any(option.value)) }"
          (keydown)="onOptionKeydown($event)"
          (click)="onSelect($any(option))"
        >
          <ng-container *ngIf="optionTemplate; else defaultOptionTemplate">
            <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option, checked: hasActive($any(option.value)) }"></ng-container>
          </ng-container>

          <ng-template #defaultOptionTemplate>
            <span
              class="med-select__list-content"
              [ngClass]="{ disabled: disabled || option.disabled }"
            >
              {{ option.label }}
            </span>
          </ng-template>
        </li>
      </ul>
    </div>
  </div>

  <div
    *ngIf="invalid"
    class="field__error-message up"
  >
    {{ errorMessage }}
  </div>
</med-label>
